import { createSlice } from "@reduxjs/toolkit";

const categorySlice = createSlice({
    name:"categories",
    initialState:{
        categories:null
    },
    reducers:{
        setCategoryList(state,action){
            state.categories = action?.payload;
        },
    }
})


export const {setCategoryList} = categorySlice.actions
export default categorySlice.reducer